module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTask),
      expression: "newTask"
    }],
    staticClass: "quick-input",
    staticStyle: {
      "margin-bottom": "10px",
      "background-color": "white"
    },
    attrs: {
      "type": "text",
      "placeholder": "Add a task..."
    },
    domProps: {
      "value": (_vm.newTask)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
        $event.preventDefault();
        return _vm.quickSaveTask(_vm.newTask)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newTask = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._l((_vm.tasks), function(task) {
    return _c('div', {
      key: task.key,
      staticClass: "task selectable clickable hoverable",
      class: {
        selected: _vm.isTaskSelected(task)
      },
      attrs: {
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
          return _vm.selectSingle(task)
        },
        "dblclick": function($event) {
          return _vm.openTask(task)
        },
        "keydown": [function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "right", 39, $event.key, ["Right", "ArrowRight"])) { return null; }
          if ('button' in $event && $event.button !== 2) { return null; }
          return _vm.increment(task, 1)
        }, function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "left", 37, $event.key, ["Left", "ArrowLeft"])) { return null; }
          if ('button' in $event && $event.button !== 0) { return null; }
          return _vm.increment(task, -1)
        }]
      }
    }, [_c('div', {
      staticClass: "indicator"
    }, [_c('div', {
      staticStyle: {
        "float": "right",
        "margin-top": "-1px",
        "margin-right": "-7px"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
        }
      }
    }, [_c('v-menu', {
      attrs: {
        "left": "",
        "offset-y": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-icon', _vm._g({
            staticClass: "menu-icon"
          }, on), [_vm._v("more_vert")])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.openTask(task)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Edit")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.toggleImportant(task)
        }
      }
    }, [_c('v-list-item-title', [(task.important) ? _c('span', [_vm._v("Not ")]) : _vm._e(), _vm._v("Important\n                        ")])], 1), _vm._v(" "), (_vm.tasks.length > 1) ? _c('v-list-item', {
      on: {
        "click": function($event) {
          if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
          return _vm.deleteTask(task)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Delete")])], 1) : _vm._e(), _vm._v(" "), (_vm.tasks.length == 1) ? _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.deleteTask(task, true)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Delete + Stop Follow Up")])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('div', {
      staticStyle: {
        "flex-basis": "1%",
        "margin-top": "-22px"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('v-checkbox', {
      on: {
        "change": function($event) {
          return _vm.taskChecked(task)
        }
      }
    })], 1), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(task.title))]), (task.important) ? _c('flag', [_vm._v("Important")]) : _vm._e(), _c('br'), _vm._v(" "), (_vm.daysTillDue(task) < 1) ? _c('div', {
      class: _vm.dueIndicatorClass(task),
      staticStyle: {
        "border-radius": "2px",
        "margin-bottom": "-1px",
        "margin-right": "2px",
        "width": "12px",
        "height": "12px",
        "background-color": "#ccc",
        "display": "inline-block"
      }
    }) : _vm._e(), _vm._v("\n                    " + _vm._s(_vm._f("dueString")(task.due))), _c('span', {
      staticStyle: {
        "font-size": "11px",
        "color": "#aaa",
        "margin-left": "4px"
      }
    }, [_vm._v(_vm._s(_vm._f("fullName")(task.assigned)))])], 1)])])])
  }), _vm._v(" "), _c('TaskDialog', {
    attrs: {
      "task": _vm.taskDialog.model,
      "settings": _vm.taskDialog.settings
    },
    on: {
      "save": _vm.saveTask
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52b11722"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/TransactionTasks.vue
// module id = 2548
// module chunks = 1